// Dev-only logging helper. Wraps console.warn so diagnostic messages for
// genuinely exceptional-but-handled situations (e.g. browser autoplay
// policy blocks, sessionStorage read/write failures) are visible during
// development but never reach the production console, where they would
// expose internal implementation details for no end-user benefit.
export const devWarn = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};
